import {Pathology} from '@legit-health/ui';

export default function isAlopecia(pathology: Pathology) {
  return (
    pathology.code === 'Alopecia areata' ||
    pathology.code === 'Hair diseases' ||
    pathology.code === 'Alopecia' ||
    pathology.code === 'Cicatricial alopecia'
  );
}
